var _dec, _dec2, _class;
import { tagName, layout as templateLayout } from '@ember-decorators/component';
import Component from '@ember/component';
import layout from '../templates/components/in-place-dialog';
let InPlaceDialog = (_dec = tagName(''), _dec2 = templateLayout(layout), _dec(_class = _dec2(_class = class InPlaceDialog extends Component {
  get containerClassNamesString() {
    const addonClassNamesString = ['ember-modal-dialog', 'ember-modal-dialog-in-place', 'emd-in-place'].join(' ');
    const containerClassNamesString = this.containerClassNames?.join && this.containerClassNames?.join(' ') || this.containerClassNames || '';
    return `${addonClassNamesString} ${containerClassNamesString}`;
  }
}) || _class) || _class);
export { InPlaceDialog as default };